import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

type Language = 'tr' | 'en';

interface LanguageContextType {
  language: Language;
  toggleLanguage: () => void;
  t: (key: string) => string;
}

const translations: Record<Language, Record<string, string>> = {
  tr: {
    'nav.home': 'Ana Sayfa',
    'nav.bilgitoplum': 'Bilgi Toplumu Hizmetleri',
    'nav.products': 'Uyum',
    'nav.about': 'Hakkımızda',
    'nav.contact': 'İletişim',
    // AltinSlider
    'altinSlider.altin': 'ALTIN',
    'altinSlider.doviz': 'DOVIZ',
    'altinSlider.ceviri': 'CEVIRI',
    'altinSlider.portfoy': 'PORTFÖY',
    'altinSlider.guvenli': 'Güvenli',
    'altinSlider.guvenliDesc': 'Fiyatlarımıza en güvenli şekilde ulaşın.',
    'altinSlider.erisilebilirlik': 'Erişilebilirlik',
    'altinSlider.erisilebilirlikDesc': 'Her zaman, her yerde fiyatlarımızı takip edebilirsiniz.',
    'altinSlider.karlilik': 'Kârlılık',
    'altinSlider.karlilikDesc': 'Güncel fiyatlar ile kazancınızı maksimize edin',
    'altinSlider.mobilUygulama': 'Mobil Uygulama',
    'altinSlider.mobilUygulamaDesc': 'Mobil uygulamamız ile her zaman yanınızdayız.',
    'altinSlider.zaman': 'Zaman',
    'altinSlider.zamanDesc': 'Telefon görüşmeleri ile zaman kaybetmeyin ve fiyat kaçırmayın.',
    'altinSlider.portfoyTitle': 'PORTFÖY',
    'altinSlider.portfoyDesc': 'Güncel fiyatlar ile kazancınızı en üst düzeye taşıyın.',
    'altinSlider.birim': 'BİRİM',
    'altinSlider.alis': 'ALIŞ',
    'altinSlider.satis': 'SATIŞ',
    'altinSlider.fiyatlarBilgi': 'Fiyatlarımız bilgi amaçlıdır.',
    // Products
    'products.dokumanlar': 'Dökümanlar',
    // Bilgitoplum
    'bilgitoplum.sirketTuru': 'ŞİRKET TÜRÜ',
    'bilgitoplum.mersis': 'MERSİS',
    'bilgitoplum.ticaretSicil': 'TİCARET SİCİL NUMARASI',
    'bilgitoplum.ticaretUnvani': 'TİCARET UNVANI',
    'bilgitoplum.adres': 'ADRES',
    'bilgitoplum.iletisimBilgileri': 'İLETİŞİM BİLGİLERİ',
    'bilgitoplum.telefon': 'TELEFON',
    'bilgitoplum.fax': 'FAX',
    'bilgitoplum.eposta': 'E-POSTA',
    'bilgitoplum.taahhutEdilenSermaye': 'TAAHHÜT EDİLEN SERMAYE MİKTARI',
    'bilgitoplum.odenenSermaye': 'ÖDENEN SERMAYE MİKTARI',
    'bilgitoplum.sirketTarih': 'ŞİRKET TESCİL TARİHİ',
    'bilgitoplum.kurulduguUlke': 'KURULDUĞU ÜLKE',
    'bilgitoplum.vergiDairesi': 'VERGİ DAİRESİ',
    'bilgitoplum.vergiNumarasi': 'VERGİ NUMARASI',
    'bilgitoplum.sektor': 'SEKTÖR',
    'bilgitoplum.yonetimKuruluBaskani': 'YÖNETİM KURULU BAŞKANI',
    'bilgitoplum.yonetimKuruluBaskanYardimcisi': 'YÖNETİM KURULU BAŞKAN YARDIMCISI',
    'bilgitoplum.yonetimKuruluUyesi': 'YÖNETİM KURULU ÜYESİ',
    'bilgitoplum.genelMudur': 'GENEL MÜDÜR',
    'bilgitoplum.denetci': 'DENETÇİ',
    // Header
    'header.menu': 'MENÜ',
    // Features
    'features.sonDuyurular': 'Son Duyurular',
    'features.duyuruText': 'Web sitemiz güncellendi, yakında daha fazla yenilikle sizlerle olacağız. Görüş ve önerileriniz bizim için önemli. İletmek istediğiniz tüm geri bildirimler için',
    'features.duyuruTextEnd': 'adresine bir e-posta bırakın.',
    'features.hizliBaglantilar': 'Hızlı Bağlantılar',
    'features.harita': 'Harita',
    'features.iletisimBilgisi': 'İletişim Bilgisi',
    'features.epostaGonder': 'E-posta Gönder',
    'features.telefonEt': 'Telefon Et',
    // ConvertCalculator
    'convertCalculator.dovizCevirici': 'Döviz Çevirici',
    'convertCalculator.miktar': 'Miktar',
    'convertCalculator.islemTuru': 'İşlem Türü',
    'convertCalculator.doviz': 'Döviz',
    'convertCalculator.parite': 'Parite',
    'convertCalculator.sarrafiye': 'Sarrafiye',
    'convertCalculator.alis': 'Alış',
    'convertCalculator.satis': 'Satış',
    'convertCalculator.kopyala': 'Kopyala',
    'convertCalculator.paraBirimleriniDegistir': 'Para Birimlerini Değiştir',
    // BottomConvertCalculator
    'bottomConvertCalculator.dovizCevirici': 'Döviz Çevirici',
    'bottomConvertCalculator.miktar': 'Miktar',
    'bottomConvertCalculator.kaynak': 'Kaynak',
    'bottomConvertCalculator.hedef': 'Hedef',
    'bottomConvertCalculator.sonuc': 'Sonuç',
    'bottomConvertCalculator.degistir': 'Para birimlerini değiştir',
    'bottomConvertCalculator.veriYok': 'Veri yok',
    // Servicesata
    'servicesata.ataAltinGrubu': 'Ata Altın Grubu',
    'servicesata.ataCeyrek': 'Ata Çeyrek',
    'servicesata.ataCeyrekDesc': 'Ata Çeyrek, ata takı grubunun en küçük üyesidir.',
    'servicesata.ataYarim': 'Ata Yarım',
    'servicesata.ataYarimDesc': 'Ata Yarım, ata takı grubunun ikinci en küçük üyesidir.',
    'servicesata.ataLira': 'Ata Lira',
    'servicesata.ataLiraDesc': 'Ata Lira, ata takı grubunun ortanca üyesidir.',
    'servicesata.ataIkibucuklu': 'Ata 2,5',
    'servicesata.ataIkibucukluDesc': 'Ata İkibuçuklu, ata takı grubunun büyük üyelerindendir.',
    'servicesata.ataBesli': 'Ata 5',
    'servicesata.ataBesliDesc': 'Ata Beşli, ata takı grubunun en büyük üyesidir.',
    'servicesata.cins': 'Cins',
    'servicesata.agirlik': 'Ağırlık',
    'servicesata.ayar': 'Ayar',
    'servicesata.cap': 'Çap',
    'servicesata.torbaAdet': 'Torba Adet',
    'servicesata.kulpsuzGram': 'Kulpsuz Gram',
    // Servicesziynet
    'servicesziynet.ziynetAltinGrubu': 'Ziynet Altın Grubu',
    'servicesziynet.ceyrekAltin': 'Çeyrek Altın',
    'servicesziynet.ceyrekAltinDesc': 'Çeyrek Altın, ziynet takı grubunun en küçük üyesidir.',
    'servicesziynet.yarimAltin': 'Yarım Altın',
    'servicesziynet.yarimAltinDesc': 'Yarım Altın, ziynet takı grubunun ikinci en küçük üyesidir.',
    'servicesziynet.ziynetLira': 'Ziynet Lira',
    'servicesziynet.ziynetLiraDesc': 'Ziynet Lira, ziynet takı grubunun ortanca üyesidir.',
    'servicesziynet.ziynetIkibucuklu': 'Ziynet 2.5',
    'servicesziynet.ziynetIkibucukluDesc': 'Ziynet İkibuçuklu, ziynet takı grubunun büyük üyelerindendir.',
    'servicesziynet.ziynetBesli': 'Ziynet 5',
    'servicesziynet.ziynetBesliDesc': 'Ziynet Beşli, ziynet takı grubunun en büyük üyesidir.',
    // ServicesProps
    'servicesProps.ziynetAltinGrubu': 'Ziynet Altın Grubu',
    'servicesProps.geriDon': 'Geri Dön',
    // AtaAra
    'ataAra.ataAltinGrubu': 'Ata Altın Grubu',
    'ataAra.subtitle': 'Güvenilir yatırımın adresi, kaliteli ata altın çeşitleri',
    'ataAra.tumUrunleriGor': 'Tüm Ürünleri Gör',
    // ZiynetAra
    'ziynetAra.ziynetAltinGrubu': 'Ziynet Altın Grubu',
    'ziynetAra.subtitle': 'Güvenilir yatırımın adresi, kaliteli ziynet altın çeşitleri',
    'ziynetAra.tumUrunleriGor': 'Tüm Ürünleri Gör',
    // Aragov
    'aragov.hasGumus': 'Has Gümüş',
    'aragov.urunlerimiz': 'Ürünlerimiz',
    'aragov.detaylarIcin': 'Detaylar İçin',
    'aragov.ziynetGrubu': 'Ziynet Grubu',
    // aragovde
    'aragovde.hasGumusUrunleri': 'Has Gümüs Ürünleri',
    // Footer
    'footer.anaSayfa': 'Ana Sayfa',
    'footer.hakkimizda': 'Hakkımızda',
    'footer.bilgiToplumHizmetleri': 'Bilgi Toplum Hizmetleri',
    'footer.iletisim': 'İletişim',
    'footer.copyright': 'AIFASOFT © 2026 Tüm hakları saklıdır.',
    'footer.kurlarBilgi': 'Tüm kurlar bilgi amaçlıdır ve piyasa verileri Foreks Hizmetleri tarafından sağlanmaktadır.',
    // About
    'about.breadcrumb': 'ANASAYFA / HAKKIMIZDA',
    'about.greeting': 'Sevgili Has Gümüş Müşterileri,',
    'about.paragraph1': '2011 yılında, Türkiye\'nin geleneksel altın ve döviz piyasası olan Kapalıçarşı\'da HAS GÜMÜŞ DEĞERLİ MADENLER DIŞ TİCARET SANAYİ LTD.ŞTİ. adıyla kurulan ilk firmamız, sarrafiye altın çeşitleri alım-satımı, standart ve standart dışı altın ve gümüş alım-satımı ile ticaret hayatına başlamıştır. Kısa sürede müşteri portföyünü genişletip, müşterisine verdiği hizmet kalitesi ile Kapalıçarşı piyasasında adından söz ettirmiş, emin adımlarla iş hacmini genişletmiştir.',
    'about.paragraph2': 'Sürekli büyüyen iş hacmi nedeniyle, 2013 Yılında HAS GÜMÜŞ DEĞERLİ MADENLER DIŞ TİCARET SANAYİ A.Ş. unvan değişikliğiyle kurumsallaşma sürecine girilmiştir.',
    'about.paragraph3': 'Firmanız 2013 yılında kurumsallaşma yolunda yeniden yapılanma çerçevesinde BORSA İSTANBUL A.Ş. üyeliğine almıştır. Borsa İstanbul aracılığıyla Fiziki İşlemler yaparak müşterilerine; yüksek finansal teknoloji altyapısı üzerinde fiziki teslimatlı altın ve gümüş alım-satım işlemi yapma imkanı sunarak Kapalıçarşı ve Türkiye genelinde kesintisiz hizmet vermeye devam etmektedir.',
    'about.vision': 'Vizyonumuz',
    'about.visionText': 'Firmamızı Türkiye\'nin saygın, dürüst ve güvenilir ALTIN VE GÜMÜŞ öncelikli olmak üzere kıymetli madenlerin ticaretini yapmak temel görüşümüzdür.',
    'about.mission': 'Misyonumuz',
    'about.missionText': 'Ortaklarına, çalışanlarına, müşterilerine, tedarikçilerine, topluma, insanlığa yardımcı olup önem vermek temel hedeflerimiz arasındadır. Yurtiçi ve Yurtdışı piyasalarda tanınmış saygın marka olmak, müşterilerine en yüksek memnuniyeti vermek görevimizdir.',
    'about.values': 'Kurumsal Değerlerimiz',
    'about.value1': 'Müşterilerimizin yaşantılarına her anlamda değer katmak temel çalışma ilkelerimizdendir.',
    'about.value2': 'Toplumsal değerlere saygılı, değişim ve gelişime açığız.',
    'about.value3': 'İlişkilerimizde ve ticaretimizde dürüstlük ve objektifliği esas alırız.',
    'about.value4': 'Etik kuralları ciddiye alan, rekabetçi anlayış davranışlarımıza yön verir.',
    'about.value5': 'Doğal kaynaklarımıza ve tarihsel mirasımızı sahip çıkıp değer katarak geleceğe aktarırız.',
    'about.value6': 'Öğrenmeye ve öğretmeye açıklığı bir işletme politikası olarak uygular ve bu doğrultuda devam ederiz.',
    'about.value7': 'Çalışanlarımız ve iş ortaklarımız için sürekli eğitim ilkesini benimser, geleceklerine yatırım yaparız.',
    'about.value8': 'Eleştirileri öğrenme fırsatı olarak görüp, kendimizi sürekli olarak geliştiririz.',
    'about.value9': 'Müşterilerimizin ürün ve hizmetlerimiz hakkındaki düşüncelerini her fırsatta alır, çözüm odaklı davranışlar geliştiririz.',
    'about.value10': 'Çalışanlarımıza değer verir, yaptığımız her işe inanır, ilişkilerimizi sevgi ve saygıya dayandırır, işimize tutku ile bağlanırız.',
    'about.value11': 'İçinde bulunduğumuz topluma karşı sosyal sorumluluklarımızın olduğu bilinci ile hareket ederiz, eğitimi desteklemeyi öncelikli hedeflerimiz arasında görürüz.',
    'about.activities': 'Faaliyetlerimiz',
    'about.activitiesText': 'HAS GÜMÜŞ DEĞERLİ MADENLER DIŞ TİCARET SANAYİ A.Ş., T.C Hazine Müsteşarlığının vermiş olduğu izin ve yetki çerçevesinde dünyada kabul görmüş ALTIN, GÜMÜŞ, PLATİN, PALADYUM, BRONZ MARKAZİT ve DEĞERLİ KIYMETLİ benzeri madenlerin ve bunlardan mamul ziynet sarrafiye ve kuyumculuk ürünlerinin ve MÜCEVHERATIN İTHALATI VE İHRACATI alım ve satımı ve anonim şirket esas mukavelesinde yazılı olan diğer işler yapılmaktadır. Bununla beraber tüm dünyada işlenmemiş & işçiliksiz standart veya standart dışı kıymetli maden (altın, gümüş, platin) ticareti, ithalatı & ihracatı faaliyetlerini yürütmektedir. Şirketimiz İstanbul Altın Borsası\'na (İAB) üye olmasının yanı sıra Elmas ve Kıymetli Taş Piyasa\'sına üyesidir.',
    // Contact
    'contact.breadcrumb': 'ANASAYFA / İLETİŞİM',
    'contact.title': 'İLETİŞİM BİLGİSİ',
    'contact.companyName': 'HAS GÜMÜŞ DEĞERLİ MADENLER',
    'contact.address': 'BEYAZIT MH. ÇARŞIKAPI NURUOSMANİYE CD. NO:43/1<br />FATİH - İSTANBUL',
    'contact.directions': 'Yol Tarifi Al',
    'contact.emailLabel': 'E-posta Gönder',
    'contact.phoneLabel': 'Telefon Et',
    'contact.whatsappLabel': 'WhatsApp ile İletişime Geç',
    // LivePrices
    'livePrices.genel': 'GENEL',
    'livePrices.doviz': 'DÖVİZ',
    'livePrices.parite': 'PARİTE',
    'livePrices.sarrafiye': 'SARRAFIYE',
    'livePrices.gramAltin': 'GRAM ALTIN',
    'livePrices.gramGumus': 'GRAM GÜMÜS',
    'livePrices.gumusUsd': 'GÜMÜS USD',
    'livePrices.usd': 'USD',
    'livePrices.birim': 'Birim',
    'livePrices.alis': 'Alış',
    'livePrices.satis': 'Satış',
    'livePrices.maden': 'MADEN',
    // FullscreenPrices
    'fullscreenPrices.doviz': 'DÖVİZ',
    'fullscreenPrices.sarrafiye': 'SARRAFIYE',
    'fullscreenPrices.maden': 'MADEN',
    'fullscreenPrices.parite': 'PARITE',
    // NotFound
    'notFound.title': '404',
    'notFound.message': 'Page Not Found',
    'notFound.goHome': 'Go to Home',
  },
  en: {
    'nav.home': 'Home',
    'nav.bilgitoplum': 'Information Society Services',
    'nav.products': 'Compliance',
    'nav.about': 'About Us',
    'nav.contact': 'Contact',
    // AltinSlider
    'altinSlider.altin': 'GOLD',
    'altinSlider.doviz': 'CURRENCY',
    'altinSlider.ceviri': 'CONVERT',
    'altinSlider.portfoy': 'PORTFOLIO',
    'altinSlider.guvenli': 'Secure',
    'altinSlider.guvenliDesc': 'Access our prices in the safest way.',
    'altinSlider.erisilebilirlik': 'Accessibility',
    'altinSlider.erisilebilirlikDesc': 'You can track our prices anytime, anywhere.',
    'altinSlider.karlilik': 'Profitability',
    'altinSlider.karlilikDesc': 'Maximize your profit with current prices',
    'altinSlider.mobilUygulama': 'Mobile App',
    'altinSlider.mobilUygulamaDesc': 'We are always with you with our mobile app.',
    'altinSlider.zaman': 'Time',
    'altinSlider.zamanDesc': 'Don\'t waste time with phone calls and miss prices.',
    'altinSlider.portfoyTitle': 'PORTFOLIO',
    'altinSlider.portfoyDesc': 'Take your profit to the highest level with current prices.',
    'altinSlider.birim': 'UNIT',
    'altinSlider.alis': 'BID',
    'altinSlider.satis': 'ASK',
    'altinSlider.fiyatlarBilgi': 'Our prices are for informational purposes.',
    // Products
    'products.dokumanlar': 'Documents',
    // Bilgitoplum
    'bilgitoplum.sirketTuru': 'COMPANY TYPE',
    'bilgitoplum.mersis': 'MERSIS',
    'bilgitoplum.ticaretSicil': 'TRADE REGISTRY NUMBER',
    'bilgitoplum.ticaretUnvani': 'TRADE NAME',
    'bilgitoplum.adres': 'ADDRESS',
    'bilgitoplum.iletisimBilgileri': 'CONTACT INFORMATION',
    'bilgitoplum.telefon': 'PHONE',
    'bilgitoplum.fax': 'FAX',
    'bilgitoplum.eposta': 'E-MAIL',
    'bilgitoplum.taahhutEdilenSermaye': 'COMMITTED CAPITAL AMOUNT',
    'bilgitoplum.odenenSermaye': 'PAID CAPITAL AMOUNT',
    'bilgitoplum.sirketTarih': 'COMPANY REGISTRATION DATE',
    'bilgitoplum.kurulduguUlke': 'COUNTRY OF ESTABLISHMENT',
    'bilgitoplum.vergiDairesi': 'TAX OFFICE',
    'bilgitoplum.vergiNumarasi': 'TAX NUMBER',
    'bilgitoplum.sektor': 'SECTOR',
    'bilgitoplum.yonetimKuruluBaskani': 'BOARD CHAIRMAN',
    'bilgitoplum.yonetimKuruluBaskanYardimcisi': 'BOARD VICE CHAIRMAN',
    'bilgitoplum.yonetimKuruluUyesi': 'BOARD MEMBER',
    'bilgitoplum.genelMudur': 'GENERAL MANAGER',
    'bilgitoplum.denetci': 'AUDITOR',
    // Header
    'header.menu': 'MENU',
    // Features
    'features.sonDuyurular': 'Latest Announcements',
    'features.duyuruText': 'Our website has been updated, we will be with you soon with more innovations. Your opinions and suggestions are important to us. For all feedback you want to share, please send an email to',
    'features.duyuruTextEnd': 'please send an email.',
    'features.hizliBaglantilar': 'Quick Links',
    'features.harita': 'Map',
    'features.iletisimBilgisi': 'Contact Information',
    'features.epostaGonder': 'Send Email',
    'features.telefonEt': 'Call',
    // ConvertCalculator
    'convertCalculator.dovizCevirici': 'Currency Converter',
    'convertCalculator.miktar': 'Amount',
    'convertCalculator.islemTuru': 'Transaction Type',
    'convertCalculator.doviz': 'Currency',
    'convertCalculator.parite': 'Parity',
    'convertCalculator.sarrafiye': 'Jewelry',
    'convertCalculator.alis': 'Bid',
    'convertCalculator.satis': 'Ask',
    'convertCalculator.kopyala': 'Copy',
    'convertCalculator.paraBirimleriniDegistir': 'Swap Currencies',
    // BottomConvertCalculator
    'bottomConvertCalculator.dovizCevirici': 'Currency Converter',
    'bottomConvertCalculator.miktar': 'Amount',
    'bottomConvertCalculator.kaynak': 'From',
    'bottomConvertCalculator.hedef': 'To',
    'bottomConvertCalculator.sonuc': 'Result',
    'bottomConvertCalculator.degistir': 'Swap currencies',
    'bottomConvertCalculator.veriYok': 'No data',
    // Servicesata
    'servicesata.ataAltinGrubu': 'Ata Gold Group',
    'servicesata.ataCeyrek': 'Ata Quarter',
    'servicesata.ataCeyrekDesc': 'Ata Quarter is the smallest member of the ata jewelry group.',
    'servicesata.ataYarim': 'Ata Half',
    'servicesata.ataYarimDesc': 'Ata Half is the second smallest member of the ata jewelry group.',
    'servicesata.ataLira': 'Ata Lira',
    'servicesata.ataLiraDesc': 'Ata Lira is the middle member of the ata jewelry group.',
    'servicesata.ataIkibucuklu': 'Ata 2.5',
    'servicesata.ataIkibucukluDesc': 'Ata Two and a Half is one of the large members of the ata jewelry group.',
    'servicesata.ataBesli': 'Ata 5',
    'servicesata.ataBesliDesc': 'Ata Five is the largest member of the ata jewelry group.',
    'servicesata.cins': 'Type',
    'servicesata.agirlik': 'Weight',
    'servicesata.ayar': 'Karat',
    'servicesata.cap': 'Diameter',
    'servicesata.torbaAdet': 'Bag Quantity',
    'servicesata.kulpsuzGram': 'Gram Without Loop',
    // Servicesziynet
    'servicesziynet.ziynetAltinGrubu': 'Jewelry Gold Group',
    'servicesziynet.ceyrekAltin': 'Quarter Gold',
    'servicesziynet.ceyrekAltinDesc': 'Quarter Gold is the smallest member of the jewelry group.',
    'servicesziynet.yarimAltin': 'Half Gold',
    'servicesziynet.yarimAltinDesc': 'Half Gold is the second smallest member of the jewelry group.',
    'servicesziynet.ziynetLira': 'Jewelry Lira',
    'servicesziynet.ziynetLiraDesc': 'Jewelry Lira is the middle member of the jewelry group.',
    'servicesziynet.ziynetIkibucuklu': 'Jewelry 2.5',
    'servicesziynet.ziynetIkibucukluDesc': 'Jewelry Two and a Half is one of the large members of the jewelry group.',
    'servicesziynet.ziynetBesli': 'Jewelry 5',
    'servicesziynet.ziynetBesliDesc': 'Jewelry Five is the largest member of the jewelry group.',
    // ServicesProps
    'servicesProps.ziynetAltinGrubu': 'Jewelry Gold Group',
    'servicesProps.geriDon': 'Back',
    // AtaAra
    'ataAra.ataAltinGrubu': 'Ata Gold Group',
    'ataAra.subtitle': 'The address of reliable investment, quality ata gold varieties',
    'ataAra.tumUrunleriGor': 'View All Products',
    // ZiynetAra
    'ziynetAra.ziynetAltinGrubu': 'Jewelry Gold Group',
    'ziynetAra.subtitle': 'The address of reliable investment, quality jewelry gold varieties',
    'ziynetAra.tumUrunleriGor': 'View All Products',
    // Aragov
    'aragov.hasGumus': 'Has Gümüş',
    'aragov.urunlerimiz': 'Our Products',
    'aragov.detaylarIcin': 'For Details',
    'aragov.ziynetGrubu': 'Jewelry Group',
    // aragovde
    'aragovde.hasGumusUrunleri': 'Has Gümüş Products',
    // Footer
    'footer.anaSayfa': 'Home',
    'footer.hakkimizda': 'About Us',
    'footer.bilgiToplumHizmetleri': 'Information Society Services',
    'footer.iletisim': 'Contact',
    'footer.copyright': 'AIFASOFT © 2026 All rights reserved.',
    'footer.kurlarBilgi': 'All rates are for informational purposes and market data is provided by Foreks Services.',
    // About
    'about.breadcrumb': 'HOME / ABOUT US',
    'about.greeting': 'Dear Has Gümüş Customers,',
    'about.paragraph1': 'Our first company, established in 2011 in the Grand Bazaar, Turkey\'s traditional gold and foreign exchange market, under the name HAS GÜMÜŞ PRECIOUS METALS FOREIGN TRADE INDUSTRY LTD., started its business life with the purchase and sale of jewelry gold varieties, standard and non-standard gold and silver. In a short time, it expanded its customer portfolio and made a name for itself in the Grand Bazaar market with the quality of service it provides to its customers, and expanded its business volume with confident steps.',
    'about.paragraph2': 'Due to the continuously growing business volume, in 2013, the process of institutionalization began with the title change to HAS GÜMÜŞ PRECIOUS METALS FOREIGN TRADE INDUSTRY INC.',
    'about.paragraph3': 'Your company became a member of BORSA İSTANBUL INC. in 2013 within the framework of restructuring on the path to institutionalization. Through Borsa İstanbul, it continues to provide uninterrupted service in the Grand Bazaar and throughout Turkey by making Physical Transactions and offering customers the opportunity to buy and sell gold and silver with physical delivery on a high financial technology infrastructure.',
    'about.vision': 'Our Vision',
    'about.visionText': 'Our basic view is to make our company a respected, honest and reliable trader of precious metals, primarily GOLD AND SILVER, in Turkey.',
    'about.mission': 'Our Mission',
    'about.missionText': 'Helping and valuing our partners, employees, customers, suppliers, society and humanity are among our main goals. It is our duty to be a recognized and respected brand in domestic and international markets and to provide the highest satisfaction to our customers.',
    'about.values': 'Our Corporate Values',
    'about.value1': 'Adding value to our customers\' lives in every sense is one of our basic working principles.',
    'about.value2': 'We respect social values and are open to change and development.',
    'about.value3': 'We base our relationships and trade on honesty and objectivity.',
    'about.value4': 'A competitive understanding that takes ethical rules seriously guides our behavior.',
    'about.value5': 'We protect our natural resources and historical heritage, add value to them and pass them on to the future.',
    'about.value6': 'We apply openness to learning and teaching as a business policy and continue in this direction.',
    'about.value7': 'We adopt the principle of continuous training for our employees and business partners and invest in their future.',
    'about.value8': 'We see criticism as an opportunity to learn and constantly improve ourselves.',
    'about.value9': 'We take our customers\' thoughts about our products and services at every opportunity and develop solution-oriented behaviors.',
    'about.value10': 'We value our employees, believe in everything we do, base our relationships on love and respect, and are passionate about our work.',
    'about.value11': 'We act with the awareness that we have social responsibilities towards the society we are in, and we see supporting education as one of our priority goals.',
    'about.activities': 'Our Activities',
    'about.activitiesText': 'HAS GÜMÜŞ PRECIOUS METALS FOREIGN TRADE INDUSTRY INC. operates within the framework of the permit and authorization granted by the Republic of Turkey Undersecretariat of Treasury, purchasing and selling GOLD, SILVER, PLATINUM, PALLADIUM, BRONZE MARCASITE and similar precious metals recognized worldwide, as well as jewelry, jewelry and jewelry products made from them, and IMPORT AND EXPORT OF JEWELRY, and other businesses written in the joint stock company\'s articles of association. In addition, it carries out trading, import and export activities of unprocessed and unprocessed standard or non-standard precious metals (gold, silver, platinum) all over the world. Our company is a member of the Istanbul Gold Exchange (IAB) as well as the Diamond and Precious Stones Market.',
    // Contact
    'contact.breadcrumb': 'HOME / CONTACT',
    'contact.title': 'CONTACT INFORMATION',
    'contact.companyName': 'HAS GÜMÜŞ PRECIOUS METALS',
    'contact.address': 'BEYAZIT MH. ÇARŞIKAPI NURUOSMANİYE CD. NO:43/1<br />FATİH - İSTANBUL',
    'contact.directions': 'Get Directions',
    'contact.emailLabel': 'Send Email',
    'contact.phoneLabel': 'Call',
    'contact.whatsappLabel': 'Contact via WhatsApp',
    // LivePrices
    'livePrices.genel': 'GENERAL',
    'livePrices.doviz': 'CURRENCY',
    'livePrices.parite': 'PARITY',
    'livePrices.sarrafiye': 'JEWELRY',
    'livePrices.gramAltin': 'GRAM GOLD',
    'livePrices.gramGumus': 'GRAM SILVER',
    'livePrices.gumusUsd': 'SILVER USD',
    'livePrices.usd': 'USD',
    'livePrices.birim': 'Unit',
    'livePrices.alis': 'Bid',
    'livePrices.satis': 'Ask',
    'livePrices.maden': 'METAL',
    // FullscreenPrices
    'fullscreenPrices.doviz': 'CURRENCY',
    'fullscreenPrices.sarrafiye': 'JEWELRY',
    'fullscreenPrices.maden': 'METAL',
    'fullscreenPrices.parite': 'PARITY',
    // NotFound
    'notFound.title': '404',
    'notFound.message': 'Page Not Found',
    'notFound.goHome': 'Go to Home',
  },
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>(() => {
    // localStorage'dan dil tercihini oku
    const savedLanguage = localStorage.getItem('language') as Language;
    return savedLanguage || 'tr';
  });

  useEffect(() => {
    // localStorage'a kaydet
    localStorage.setItem('language', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage((prevLanguage) => (prevLanguage === 'tr' ? 'en' : 'tr'));
  };

  const t = (key: string): string => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

